@if (isLocalhost) {
  <!-- Trigger button -->
  <button
    class="impersonator-trigger"
    [class.impersonator-trigger--active]="isImpersonating()"
    (click)="togglePanel()"
    title="Role Impersonator (Dev Only)"
    type="button"
  >
    <i class="fas fa-user-secret"></i>
    @if (isImpersonating()) {
      <span class="impersonator-trigger__badge">!</span>
    }
  </button>

  <!-- Password prompt -->
  @if (showPasswordPrompt()) {
    <div class="impersonator-password-prompt">
      <div class="impersonator-password-prompt__header">
        <i class="fas fa-lock"></i>
        <span>Enter dev password</span>
      </div>
      <input
        #passwordInput
        class="impersonator-password-prompt__input"
        [class.impersonator-password-prompt__input--error]="passwordError()"
        type="password"
        placeholder="Password"
        (keydown.enter)="submitPassword(passwordInput.value)"
        (keydown.escape)="cancelPassword()"
        autofocus
      />
      @if (passwordError()) {
        <span class="impersonator-password-prompt__error">Incorrect password</span>
      }
      <div class="impersonator-password-prompt__actions">
        <button
          class="impersonator-password-prompt__btn impersonator-password-prompt__btn--cancel"
          type="button"
          (click)="cancelPassword()"
        >
          Cancel
        </button>
        <button
          class="impersonator-password-prompt__btn impersonator-password-prompt__btn--submit"
          type="button"
          (click)="submitPassword(passwordInput.value)"
        >
          Unlock
        </button>
      </div>
    </div>
  }

  <!-- Panel -->
  @if (isPanelOpen()) {
    <div class="impersonator-panel">
      <div class="impersonator-panel__header">
        <span class="impersonator-panel__title">
          <i class="fas fa-flask"></i>
          Role Impersonator
        </span>
        <span class="impersonator-panel__env-tag">LOCALHOST ONLY</span>
      </div>

      @if (isImpersonating()) {
        <div class="impersonator-panel__status impersonator-panel__status--active">
          <i class="fas fa-circle-check"></i>
          Impersonating as <strong>{{ activeRole() }}</strong>
          <button
            class="impersonator-panel__clear-btn"
            (click)="clearImpersonation()"
            type="button"
          >
            <i class="fas fa-xmark"></i> Exit & Reload
          </button>
        </div>
      } @else {
        <div class="impersonator-panel__status">
          <i class="fas fa-circle-user"></i>
          Using your real session profile
        </div>
      }

      <p class="impersonator-panel__hint">
        Select a user type to reload the app with that profile.
      </p>

      <div class="impersonator-panel__roles">
        @for (profile of profiles; track profile.label) {
          <button
            class="impersonator-role-btn"
            [class.impersonator-role-btn--selected]="activeRole() === profile.label"
            (click)="selectRole(profile)"
            type="button"
          >
            <i class="fas {{ profile.icon }} impersonator-role-btn__icon"></i>
            <span class="impersonator-role-btn__info">
              <span class="impersonator-role-btn__label">{{ profile.label }}</span>
              <span class="impersonator-role-btn__desc">{{ profile.description }}</span>
            </span>
            @if (activeRole() === profile.label) {
              <i class="fas fa-check impersonator-role-btn__check"></i>
            }
          </button>
        }
      </div>
    </div>
  }
}
